import React from 'react';
import PropTypes from "prop-types";
import {Link, useParams} from "react-router-dom";

const PageNotFound = (props) => {

    const params  = useParams();
    console.log('PageNotFound', {params}) 
    return (
        <div className="flex items-center justify-center">
            <div className="page-error" style={TB.createStyledCircle(TB.config("color.info"), 0.1)}>

                <div className="white-panel">
                    <h1>404</h1>

                    <h3>Page not found</h3>

                    <p>The link you clicked may be broken or the page may have been renamed or removed.</p>

                    <Link
                        replace={true}
                        to={props.exitLink || TB.auth().appropriate()}
                        className="btn btn-primary mt-2">
                        {props.exitText || "Return to dashboard"}
                    </Link>
                </div>

            </div>
        </div>
    );
};

PageNotFound.propTypes = {
    exitLink: PropTypes.any,
    exitText: PropTypes.any,
};

export default PageNotFound;